import React, { Fragment } from 'react';
import { BulkDeleteButton } from 'react-admin';

const BulkActionButtons = props => (
    <Fragment>
        <BulkDeleteButton {...props} />
    </Fragment>
);

export default BulkActionButtons;